  
import Accordion from '@mui/material/Accordion'; 
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
 
import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
const Return = () =>{
    return(
        <>
         <Header />
         <div className="container-fluid">
          <div className="container">
            <div className="row">
                <div className="col-lg-12 mt_30 pt_20">
                <div className="heading_common mt_15">
                     <h3> Cancellation & Returns </h3>
                 </div>
                </div>
            </div>
        </div>
        <div className="container">
            <div className="row">
                <div className="col-lg-12 mt_15">
                <div className="accordian_box mt_15" >
                <Accordion defaultExpanded>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                        >
                        <Typography component="span"><h6>Can I modify/change the specification for the ordered product without cancelling it?</h6></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                       No, once an order is placed the specification of the product can not be modified.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                        >
                        <Typography component="span"><h6>Why i am getting charged for cancellation? / What is cancellation Fee?</h6></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                        Cancellation fee will be applied or charged only if an eligible order is cancelled after 24 hours of placing.
                        The reason is to compensate for the time and effort incurred in processing the order by the seller. Also, to compensate our logistics partner for incurring a cost when they ship the order, if the order is shipped. Note: Customer can find this information under the order details by logging into his/her Flipkart account.
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                        >
                        <Typography component="span"><h6>I see the 'Cancel' button but I can't click on it. Why?</h6></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <p>A greyed-out 'Cancel' button may indicate:</p>
                         <p><span className="common_color"> - </span> The item is out for delivery or already delivered. </p>
                          <p><span className="common_color"> - </span>  The item is non-refundable (e.g., digital products like Gift Cards). </p>
                           <p><span className="common_color"> - </span> The cancellation window has passed and doorstep cancellations may incur fees. </p>
                            <p>Check the product's cancellation policy before purchase for clarity.  </p>
                        
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                        >
                        <Typography component="span"><h6>How long does it take to cancel an order?</h6></Typography>
                        </AccordionSummary>
                        <AccordionDetails> 
                        If the seller hasn’t shipped the order, it will be canceled immediately. If already shipped, cancellation occurs once the delivery partner confirms the return.
                        In some cases, a cancellation fee may apply if cancelled after the specified time. Cancellation windows vary by category, and doorstep cancellations may also incur fees. Please check the product page for details.
                     </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                        >
                        <Typography component="span"><h6>Can I reinstate a cancelled order?</h6></Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            Once an order is cancelled, it cannot be processed or delivered. It is recommended that you place a new order based on availability.
                            To locate the product quickly, visit the 'Orders' section of your Flipkart account and select 'Buy now'.
                         </AccordionDetails>
                    </Accordion>
                     
                    
                     </div>
                </div>
            </div>
        </div>
        </div>
        <Subscribe /> 
        <Footer />

        </>
    )
}

export default Return;